// extracted by mini-css-extract-plugin
module.exports = {"list":"index_list_1CHj3","item":"index_item_2oBUo"};